/**
 * CR444: FlyerSnippetBlock — UNCONDITIONAL rendering with mount sentinel.
 * If enabled: always renders image OR placeholder. Never blank.
 */

import React from "react";
import type { DealCardBlockProps } from "@/lib/deal-cards/specV2/types";
import type { Deal } from "@/lib/types/deals";
import { FlyerPreview } from "@/components/deals/FlyerPreview";

export const FlyerSnippetBlock: React.FC<DealCardBlockProps<Deal>> = ({ deal, block }) => {
  if (!block?.enabled) return null;

  return (
    <div
      data-block="flyer_snippet"
      data-deal-id={(deal as any)?.id ?? ""}
      data-dedupe-key={(deal as any)?.dedupe_key ?? ""}
      className="w-full my-1"
    >
      <FlyerPreview deal={deal as any} />
    </div>
  );
};

export default FlyerSnippetBlock;
